import React from "react"
import { useParams } from "react-router-dom"
import { useTranslate } from "ra-core"
import { Box } from "@mui/material"
import BarChartIcon from "@mui/icons-material/BarChart"
import TableIcon from "@mui/icons-material/TableRowsTwoTone"
import ScheduleIcon from "@mui/icons-material/Schedule"
import { RecordActionsTabs, SubTabProps } from "components/ui/layouts"
import { Title } from "react-admin"
import { DDTChart } from "components/charts"


const TabList = () => {
    const translate = useTranslate()

    const subTabs: SubTabProps[] = [
        { label: translate("resources.schedules.name"), name: "schedules", resource: "devices", icon: <ScheduleIcon/> },
        { label: translate("resources.devices.data"), name: "data", resource: "devices", icon: <TableIcon/> },
        { label: translate("resources.devices.chart"), name: "chart", resource: "devices", icon: <BarChartIcon/> },
    ]

    return (
        <Box display="flex" flexDirection="column" width="100%">
           <RecordActionsTabs subTabs={subTabs} resourceParent="devices"/>
        </Box>
    )
}

function DDTChartPageComponent(): JSX.Element {
    const translate = useTranslate()
    const { id } = useParams<{ id: string }>()

    
    return (
        <>
        <Title title={translate('resources.devices.chart')}/>
        <TabList />
        <DDTChart id={id!} />
        </>
    )
}

export default DDTChartPageComponent
